// import G6 ,{ModelConfig, Graph, INode} from "@antv/g6"

const G6=(window as any).G6;
const nodePcType='node-pc';
const nodeGatewayType='node-gateway';
const nodeDeviceType='node-device';
const edgePcDeviceType='edge-pc-device';
const edgeGatewayDeviceType='edge-gateway-device';
const edgePcGatewayType='edge-pc-gateway';


const pcImg = 'data:image/svg+xml;base64,PHN2ZyB0PSIxNjQ1MTc2MzY3MDYzIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDE2NDUgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjU0OTIiIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCI+PHBhdGggZD0iTTExMzMuNzE0Mjg2IDEwMjRWMGg1MTJ2MTAyNEgxMTMzLjcxNDI4NnpNMTU3Mi41NzE0MjkgNzMuMTQyODU3SDEyMDYuODU3MTQzdjIxOS40Mjg1NzJoMzY1LjcxNDI4NlY3My4xNDI4NTd6IG0wIDM2NS43MTQyODZIMTIwNi44NTcxNDN2NTEyaDM2NS43MTQyODZWNDM4Ljg1NzE0M3ogbS03My4xNDI4NTggNDM4Ljg1NzE0M2gtMjE5LjQyODU3MXYtNzMuMTQyODU3aDIxOS40Mjg1NzF2NzMuMTQyODU3eiBtLTE4Mi44NTcxNDItMzI5LjE0Mjg1N2gxNDYuMjg1NzE0djE0Ni4yODU3MTRoLTE0Ni4yODU3MTR2LTE0Ni4yODU3MTR6IG0wLTQwMi4yODU3MTVhMzYuNTcxNDI5IDM2LjU3MTQyOSAwIDEgMS0zNi41NzE0MjkgMzYuNTcxNDI5IDM2LjU3MTQyOSAzNi41NzE0MjkgMCAwIDEgMzYuNTcxNDI5LTM2LjU3MTQyOXogbTE0Ni4yODU3MTQgMGEzNi41NzE0MjkgMzYuNTcxNDI5IDAgMSAxLTM2LjU3MTQyOSAzNi41NzE0MjkgMzYuNTcxNDI5IDM2LjU3MTQyOSAwIDAgMSAzNi41NzE0MjktMzYuNTcxNDI5ek01ODUuMTQyODU3IDk1MC44NTcxNDNoMTQ2LjI4NTcxNHY3My4xNDI4NTdIMjkyLjU3MTQyOXYtNzMuMTQyODU3aDE0Ni4yODU3MTR2LTE0Ni4yODU3MTRIMFY3My4xNDI4NTdoMTAyNHY3MzEuNDI4NTcySDU4NS4xNDI4NTd2MTQ2LjI4NTcxNHogbTM2NS43MTQyODYtMjE5LjQyODU3MlYxNDYuMjg1NzE0SDczLjE0Mjg1N3Y1ODUuMTQyODU3aDg3Ny43MTQyODZ6IiBwLWlkPSI1NDkzIj48L3BhdGg+PC9zdmc+';
const gatewayImg = 'data:image/svg+xml;base64,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';
const ethImg = 'data:image/svg+xml;base64,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';
const deviceImg = 'data:image/svg+xml;base64,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';

const removeImg = 'data:image/svg+xml;base64,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'

const BorderSize=3;
const BorderColor='#409EFF';
const BorderSelectSize=5;
const BorderSelectColor='#67C23A';
const FontSize=16;
const FontSizeTitle=20;

export class ExtranetUi{
  
  private _data?:ExtranetData=undefined;
  private _graph: any=undefined;

  private _connectSource: any = undefined;

  private _selectDeviceNode: any = undefined;

  private _maxDeviceCount: Number = 0;

  public get maxDeviceCount(): Number{
    return this._maxDeviceCount;
  }
  public set maxDeviceCount(value: Number) {
    this._maxDeviceCount=value;
  }

  private _removeFeature: boolean = false;

  public get removeFeature(): boolean{
    return this._removeFeature;
  }
  public set removeFeature(value: boolean) {
    this._removeFeature=value;
  }

  private _beforeRemoveDevice: (name:string) => Promise<boolean> =()=>{
    return new Promise((resolve, reject)=>{
      reject();
    })
  };

  public get beforeRemoveDevice(): (name:string) => Promise<boolean>{
    return this._beforeRemoveDevice;
  }
  public set beforeRemoveDevice(value:(name:string) => Promise<boolean>) {
    this._beforeRemoveDevice=value;
  }

  public constructor(domId:string){
    this.createSharp(domId);
  }

  public init(data: ExtranetData){
    this.render(data);
    this.graphOn();
    this.selectNode(data.pc.id)
  }

  public destroy(){
    this._graph?.destroy();
  }

  public getExtranetData(){
    if(!this._graph){
      return;
    }

    const nodeList = this._graph.findAll('node',item=>{
      return true;
    });

    const pcNode = nodeList.find(c=>c.get('model').dataType==='pc');
    const gatewayNode = nodeList.find(c=>c.get('model').dataType==='gateway');
    const deviceNodeList = nodeList.filter(c=>c.get('model').dataType==='device');
    

    const data = new ExtranetData();
    data.pc = pcNode.get('model').meta?.data as PcData;
    data.gateway = gatewayNode.get('model').meta?.data as GatewayData;
    data.deviceDataList = deviceNodeList.map(c=> c.get('model').meta?.data as DeviceData);
    return data;
  }

  private selectNode(nodeId){
    if(!this._graph){
      return;
    }
    const sharp = this._graph.findById(nodeId);
    if(sharp.get('currentShape')===nodeDeviceType){
      this._selectDeviceNode=sharp;
    }else{
      this._selectDeviceNode=undefined;
    }
    const nodes = this._graph.getNodes();
    nodes.forEach((node)=>{
      this._graph.setItemState(node, 'selected', nodeId===node._cfg.id)
    })
    this.emitSelect(sharp);

  }

  private emitSelect(sharpe){
    this._graph.emit('wiminode:select',{
      nodeId: sharpe.get('id'),
      type:sharpe._cfg.model.dataType,
      mode:sharpe._cfg.model.mode,
      data:(<any>sharpe._cfg.model).meta?.data});
  }

  private canAdd(){
    const nodeList = this.findAllDeviceNode();
    return nodeList.length<this._maxDeviceCount;
  }

  public update(nodeId,key,value){
    

    if(!this._graph){
      return;
    }

    const sharp = this._graph.findById(nodeId);
    
    this._graph.updateItem(sharp,{});

  }

  private createSharp(domId:string){
    const container = document.getElementById(domId);
    const width = container.scrollWidth;
    const height = 1000;
    
    this._graph = new G6.Graph({
      container: domId, 
      width: width, 
      height: height, 
      modes: {
        default: [
          {
            type: 'drag-node',
            shouldBegin: e => {
              
              if (e.target.get('name') === 'pc-point' || e.target.get('name')==='pc-point-image') {
                return false;
              }
              return true;
            }
          },
          {
            type:'create-edge',
            trigger: 'drag',
            shouldBegin: e => {
              if(this.canAdd()===false){
                return false;
              }
              if(e.item.get('currentShape')!==nodePcType){
                return false;
              }
              this._connectSource=e;
              return true;
            },
            shouldEnd: e => {
              
              if (e.target.get('cType') !== 'gateway-point'){
                return false;
              } 
              
              if (e.target) {
                this.renderDeviceItem(this._connectSource, e)
                return false;
              }
              return false;
            },
          }],
      }
      ,defaultEdge: {
        style: {
          stroke: '#F6BD16',
          lineWidth: 4,
        },
      },
    });
  }

  private render(data: ExtranetData){
    this._data=data;
    const renderData=this.getReanderData(data);
    this._graph.data(renderData); 
    this._graph.render();
    
  }

  private get gatewayNoNetworkInterface(){
    return this._data.gateway.networkDataList.length==0;
  }

  public changeRemoveFeature(feature: boolean){
    this._removeFeature=feature;
    const nodeList = this.findAllDeviceNode();
    nodeList.forEach(node=>{
      node.update({
        removeFeature: feature
      });
    });
  }

  public updateExtranetData(data:ExtranetData){
    // this._deviceList=[];
    if(!data.pc.id){
      data.pc.id=`pc_${nanoid()}`;
    }
    if(!data.gateway.id){
      data.gateway.id=`gateway_${nanoid()}`;
    }
    if(!data.gateway.virtualIp){
      data.gateway.virtualIp= this.replaceEndIp(data.pc.virtualIp,'60');
    }
    
    if(data.deviceDataList){  
      data.deviceDataList.forEach(item=>{
        if(!item.id){
          item.id=`device_${nanoid()}`;
        }
        // this._deviceList.push(item.id);   
      })
    }
    
    this.render(data);

    if(data.deviceDataList){  
      data.deviceDataList.forEach((item,index)=>{
        this.renderDevice(data.pc,data.gateway,item,index);
      })
    }

    
    this.selectNode(data.pc.id);
  }

  private renderDevice(pc:PcData,gateway: GatewayData,device: DeviceData,index){

    const deviceNodeId = device.id;
    const edgeId= `edge_${deviceNodeId}`;
    const deviceName=device.name;
    const targetAnchorIndex = gateway.networkDataList.findIndex(c=>c.ip===device.linkGatewayIp);

    const y =150+index*75;

    this.renderDeviceNodeAndEdge({
      deviceNodeId,deviceName,edgeId,
      y,
      ipClone:device.ipClone,
      virtualIp:device.virtualIp,
      physicalIp:device.physicalIp,
      linkGatewayIp: device.linkGatewayIp,
      gatewayPointIndex:targetAnchorIndex+1,
      gatewayId: gateway.id,
      pcId: pc.id,
      physicalName: device.physicalName
    });

  }

  private renderDeviceItem(sourceEvt, targetEvt){
  

    if(!this._graph){
      return;
    }

    const deviceNodes = this._graph.findAll('node', (node)=>{
      return node.get('currentShape')===nodeDeviceType;
    })
    const yList = deviceNodes.map(node=>{
      return node._cfg.model.y;
    })
    const maxY = Math.max(0,...yList);
    
    let positionY = 150;
    if(maxY>0){
      positionY=maxY+75;
    }
    
    const pcVirtualIp= sourceEvt.item.get('model').meta.data.virtualIp;
    
    const targetData = targetEvt.target.cfg.data;
    const sourceId = sourceEvt.item.get('id');
    const targetId = targetEvt.item.get('id');
    const targetAnchorIndex = targetEvt.target.cfg.anchorPointIdx;
    const linkGatewayIp = targetData?.ip;
    const physicalIp = this.replaceEndIp(targetData?.ip,'200');
    const deviceNodeId =`device_${nanoid()}`;
    const edgeId= `edge_${deviceNodeId}`;
    const deviceName = `设备 ${deviceNodes.length+1}`;
    const virtualIp = this.distributeIp(pcVirtualIp,deviceNodes.length);
    const y = positionY; 

    const physicalName =targetData?.name

    this.renderDeviceNodeAndEdge({
      deviceNodeId,deviceName,edgeId,
      y,
      ipClone:false,
      virtualIp,
      physicalIp,
      linkGatewayIp,
      gatewayPointIndex:targetAnchorIndex,
      gatewayId: targetId,
      pcId: sourceId,
      physicalName
    });
    this.selectNode(deviceNodeId);
  }

  private renderDeviceNodeAndEdge(data:DeviceAndEdgeModel){
    const model = {
      type: nodeDeviceType,
      id: data.deviceNodeId,
      name: data.deviceName,
      pcDeviceEdgeId: data.edgeId,
      x: 250,
      y: data.y,
      dataType:'device',
      removeFeature: this._removeFeature,
      mode: this.gatewayNoNetworkInterface?'pc-gateway': undefined,
      meta:{
        data:{
          id: data.deviceNodeId,
          name: data.deviceName,
          virtualIp: data.virtualIp,
          physicalIp: data.physicalIp,
          ipClone: data.ipClone,
          linkGatewayIp: data.linkGatewayIp,
          physicalName: data.physicalName
        }
      }
    };
  
    this._graph.addItem('node', model);
  
    this._graph.addItem('edge', {
      type: edgePcDeviceType,
      id: data.edgeId,
      source: data.pcId,
      target: data.deviceNodeId,
      sourceAnchor: 0,
      lineDash: [4, 2, 1, 2],
      running: false,
      cType:'pc_device_edge',
      style:{
        lineDash:[5,5,5]
      }
    });

    this._graph.addItem('edge', {
      type: edgeGatewayDeviceType,
      source: data.deviceNodeId,
      target: data.gatewayId,
      targetAnchor: data.gatewayPointIndex,
      cType:'gateway_device_edge',
    });
    

  }

  public onSelected(callback: (e: any) => void){
    if(!this._graph){
      return;
    }
    (<any>this._graph).on('wiminode:select', evt=> {
      callback(evt);
    });
  }

  private remoteNodeById(nodeId:string){
    if(!this._removeFeature){
      return;
    }
    const shape = this._graph.findById(nodeId);
    const name = shape.get('model').name;
    this._beforeRemoveDevice(name).then(res=>{
        // 删除节点
        this._graph.removeItem(shape);
        const pcNode=this._graph.getNodes()[0];
        this.selectNode(pcNode.get('id'));
        // 更新节点位置
        this.refreshDeviceNodePosition();    
    })
    .catch(err=>{});
    
  }

  public updateIpRepeat(){
    const nodeList = this._graph.findAll('node', (node)=>{
      return true;
    })
    nodeList.forEach(node=>{
      node.update({
        repeatIp: this.findDistinctIpList()
      });
    });
  }

  public findDistinctIpList(){
    const ipList = this.findAllIpList();
    const repeatIp = ipList.filter((v,i) =>{ return ipList.indexOf(v) !== ipList.lastIndexOf(v); });
    
    return repeatIp;
  }

  public findAllIpList(){
    const data = this.getExtranetData();
    const ipList=[];
    ipList.push(data.pc.virtualIp);
    ipList.push(data.gateway.virtualIp);
    ipList.push(...data.gateway.networkDataList.map(c=>c.ip));
    ipList.push(...data.deviceDataList.map(c=>c.virtualIp));
    ipList.push(...data.deviceDataList.map(c=>c.physicalIp));
    return ipList;
  }

  private refreshDeviceNodePosition(){
    const deviceNodeList = this.findAllDeviceNode();
    deviceNodeList.forEach((node: any,index)=>{
      const cfg= {
        x: 250,
        y: 150 + index*75
      }
      node.updatePosition(cfg);
      node.getEdges().forEach(edge=>{
        edge.refresh();
      });
    });
  }

  private findAllDeviceNode(){
    if(!this._graph){
      return [];
    }

    return this._graph.findAll('node', (node)=>{
      return node.get('currentShape')===nodeDeviceType;
    });
  }

  private graphOn(){
    if(!this._graph){
      return;
    }

    
    this._graph.on('node:click', evt=> {
      const nodeId = evt.item._cfg.id;
      
      

      this.selectNode(nodeId);
      if(evt.target.get('name')==='remove-image'){
        this.remoteNodeById(nodeId);
      }
    });


    this._graph.on('keyup', evt=> {
      if(evt && evt.code==='Delete'){
        if(this._selectDeviceNode){
          // alert('删除节点');
          this.remoteNodeById(this._selectDeviceNode.get('id'));
        }
      }
    });


  }

  private distributeIp(sourceIp, index){
    const ipMin=100;
    const ipMax=150;
    const ipArray = sourceIp.split(".");
    ipArray[3]=ipMin+index;
    if(ipArray[3]>ipMax){
      ipArray[3]=ipArray[3]-ipMax;
    }
    return ipArray.join('.');
  }

  private replaceEndIp(sourceIp, endIp){
    if(!sourceIp){
      return '192.168.0.10'
    }
    const ipArray = sourceIp.split(".");
    ipArray[3]=endIp;
    return ipArray.join('.');
  }
  

  private getReanderData(data: ExtranetData){
    const networkList = data.gateway.networkDataList.map(c=>({
      type: 'l',
      name: c.name,
      ip: c.ip
    }));
    const renderData = {
      // 点集
      nodes: [
        {
          type: nodePcType, 
          title:'本机',
          color: BorderColor,
          id: data.pc.id, 
          x: 20,
          y: 50,
          dataType:'pc',
          meta:{
            data: data.pc
          }
        },
        {
          type: nodeGatewayType, 
          title: data.gateway.code,
          color: BorderColor,
          id: data.gateway.id, 
          x: 450,
          y: 50,
          interfaces:[...networkList],
          dataType:'gateway',
          meta:{
            data: data.gateway
          }
        },
        
      ],
      // 边集
      edges: [
      ],
    };
    return renderData;
  }

}

export class ExtranetData{
  public pc:PcData=new PcData();
  public gateway:GatewayData=new GatewayData();
  public deviceDataList: DeviceData[]=[]
}

export class PcData{
  public id:string;
  public virtualIp:string='172.16.0.10';
}

export class GatewayData{
  public code: string;
  public id:string;
  public virtualIp: string;
  public networkDataList: GatewayNetworkData[]=[]
}

export class GatewayNetworkData{
  public name:string;
  public ip:string;
}

export class DeviceData{
  public id:string;
  public name: string;
  public virtualIp:string;
  public physicalIp:string;
  public ipClone:boolean=false;
  public linkGatewayIp: string ;
  public physicalName: string;
}

interface IMetaModel{
  data: DeviceData | GatewayData | PcData;
}

interface DeviceAndEdgeModel{
  deviceNodeId:string;
  deviceName:string;
  edgeId:string;
  y:number;
  virtualIp:string;
  physicalIp:string;
  ipClone:boolean;
  linkGatewayIp:string;
  gatewayPointIndex:number;
  pcId:string;
  gatewayId:string;
  physicalName: string;
}

function registerPcNode(){
  
  G6.registerNode(
    nodePcType,
    {
      drawShape: function drawShape(cfg, group) {
        
        const virtualIp= ((cfg.meta as IMetaModel)?.data as PcData).virtualIp
        const r = 2;
        const keySharpe = group.addShape('rect', {
          attrs: {
            x: 0,
            y: 0,
            width: 200,
            height: 80,
            radius: r,
          },
          draggable: true,
          name: 'key-box',
        });
        group.addShape('rect', {
          attrs: {
            x: 0,
            y: 0,
            width: 200,
            height: 50,
            stroke: BorderColor,
            fill: '#fff',
            radius: r,
            lineWidth: BorderSize,
          },
          draggable: true,
          name: 'main-box',
        });
        group.addShape('rect', {
          attrs: {
            x: 40,
            y: 50,
            width: 120,
            height: 30,
            stroke: BorderColor,
            fill: '#fff',
            radius: r,
            lineWidth: BorderSize,
          },
          draggable: true,
          name: 'main-box1',
        });

        group.addShape('text', {
          attrs: {
            textBaseline: 'top',
            x: 80,
            y: 15,
            fontWeight: 800,
            fontSize: FontSizeTitle,
            text: cfg.title,
            fill: '#000',
          },
          name: 'title',
        });

        group.addShape('text', {
          attrs: {
            textBaseline: 'top',
            x: 55,
            y: 55,
            fontSize: FontSize,
            text: virtualIp,
            fill: '#000',
          },
          name: 'text-virtualIp',
          id: 'text-virtualIp',
        });

        
        group.addShape('image', {
          attrs: {
            x: 150,
            y: 0,
            height: 45,
            width: 45,
            img: pcImg,
            cursor: 'pointer',
          },
          name: 'pc-image',
        });
        return keySharpe;
      },
      
      getAnchorPoints(cfg) {
        return cfg.anchorPoints || [[0.5,1]];
      },
      afterDraw(cfg, group){
        const points = this.getAnchorPoints(cfg);
        points.forEach((anchorPos, i) => {
          group.addShape('circle', {
            attrs: {
              r: 10,
              x: 100,
              y: 80,
              fill: '#fff',
              stroke: BorderColor,
              lineWidth: BorderSize,
            },
            name: `anchor-point`, // the name, for searching by group.find(ele => ele.get('name') === 'anchor-point')
            anchorPointIdx: i, // flag the idx of the anchor-point circle
            links: 0, // cache the number of edges connected to this shape
            visible: true, // invisible by default, shows up when links > 1 or the node is in showAnchors state
            draggable: true // allow to catch the drag events on this shape
          });

          
          group.addShape('image', {
            attrs: {
              x: 90,
              y: 70,
              height: 20,
              width: 20,
              img: ethImg,
              cursor: 'pointer',
            },
            anchorPointIdx: i,
            name: 'pc-point-image',
            draggable: true,
          });
          
        
        })
      },
      update(cfg,node){
        const virtualIp= (<any>cfg.meta)?.data?.virtualIp
        const group = node.get('group');
        const textVirtualIpSharp = group.findById('text-virtualIp');
        textVirtualIpSharp.attr('text',virtualIp);

        if(cfg.repeatIp && (cfg.repeatIp as any[]).findIndex(c=>c===virtualIp)>-1){
          textVirtualIpSharp.attr('fill','#F56C6C');
        } else{
          textVirtualIpSharp.attr('fill','#000');
        }
      },
      setState(name, value, item){
        const model={
          fill: value? '#d1edc4': '#fff',
          stroke: value? BorderSelectColor :  BorderColor,
          lineWidth: value? BorderSelectSize : BorderSize
        }
        const group = item.get('group');
        if(name==='selected'){
          const sharpList =  group.findAll(item=> {
            return (item.get('type')==='rect' && item.get('name')!=='key-box') || item.get('type')==='circle';
          });
          sharpList.forEach(sharp=>{
            sharp.attr(model);
          });
        }

      },
    },
    'single-node',
  );
}

function registerGatewayNode(){
  
G6.registerNode(
  nodeGatewayType,
  {
    drawShape: function drawShape(cfg:any, group) {
      const virtualIp = (<any>cfg.meta)?.data?.virtualIp;
      
      
      const r = 2;
      
      const interfaceHeight = (<any>cfg).interfaces.length * 40;

      const keySharpe = group.addShape('rect', {
        attrs: {
          x: 0,
          y: 0,
          width: 200,
          height: 100 + interfaceHeight,
          stroke: BorderColor,
          fill: '#fff',
          radius: r,
        },
        name: 'key-sharper',
        draggable: true,
      });


      group.addShape('rect', {
        attrs: {
          x: 0,
          y: 0,
          width: 200,
          height: 100,
          stroke: BorderColor,
          radius: r,
          lineWidth: BorderSize
        },
        name: 'main-box',
        draggable: true,

      });
      group.addShape('text', {
        attrs: {
          textBaseline: 'top',
          x: 15,
          y: 50,
          fontWeight: 800,
          fontSize: FontSizeTitle,
          text: virtualIp,
          fill: '#000',
        },
        name: 'vip',
        id:'text-virtualIp'
      });
      
      group.addShape('text', {
        attrs: {
          textBaseline: 'top',
          x: 15,
          y: 15,
          fontWeight: 800,
          fontSize: 16,
          text: cfg.title,
          fill: '#000',
        },
        name: 'title',
      });

      (<any>cfg).interfaces.forEach((item, index) => {
        group.addShape('rect', {
          attrs: {
            x: 0,
            y: 100+(index*40),
            width: 200,
            height: 40,
            radius: r,
            stroke: BorderColor,
            lineWidth: BorderSize
          },
          name: `rect-${item.name}`,
        });

        group.addShape('text', {
          attrs: {
            textBaseline: 'top',
            x: 30,
            y: 110+(index*40),
            fontSize: FontSize,
            text: `${item.name}[${item.ip}]`,
            fill: '#000',
          },
          name: `title-${index}`,
          dataType:'text-interface-ip',
          dataIp: item.ip
        });

      });

      group.addShape('image', {
        attrs: {
          x: 150,
          y: 50,
          height: 45,
          width: 45,
          img: gatewayImg,
          cursor: 'pointer',
        },
        name: 'gateway-image',
      });

      return keySharpe;
    },
    getAnchorPoints(cfg) {
      const interfaceHeight = (<any>cfg).interfaces.length * 40;
      const totalHeight = 100 + interfaceHeight;
      const points = [];
      (<any>cfg).interfaces.forEach((item,index)=>{
        const pointY = 100+ 20 + 40*(index);
        points.push([0, pointY/totalHeight]);
      });
      points.unshift([0,40/totalHeight]);
      

      return points;
    },
    afterDraw(cfg, group){
      console.log('cfg.mode:', cfg.mode);
      const virtualIp= (<any>cfg.meta)?.data?.virtualIp
      const points = this.getAnchorPoints(cfg);
      points.forEach((anchorPos, i) => {
        if(i<1 && cfg.mode===undefined){
          // 第一个节点比较特殊
          return;
        }

        const dataInterface= (<any>cfg).interfaces[i-1];
        const data = i===0?{
          ip: virtualIp,
          name: "veth",
          type: "v",
        }: dataInterface;

        group.addShape('circle', {
          attrs: {
            x: 0,
            y: i==0? 50 :120+((i-1)*40),
            r: 10,
            fill: '#fff',
            stroke: BorderColor,
            lineWidth: BorderSize

          },
          anchorPointIdx: i, // flag the idx of the anchor-point circle
          cType: 'gateway-point',
          data: data,
          name: `point-${i}`,
          links: 0, // cache the number of edges connected to this shape
          visible: true, // invisible by default, shows up when links > 1 or the node is in showAnchors state
          draggable: false 
        });

        group.addShape('image', {
          attrs: {
            x: -10,
            y: i==0? 40 :120+((i-1)*40) - 10,
            height: 20,
            width: 20,
            img: ethImg,
            cursor: 'pointer',
          },
          anchorPointIdx: i,
          data: data,
          name: 'gateway-point-image',
          cType: 'gateway-point',
        });
      
      })
    },
    update(cfg,node){
      const virtualIp= (<any>cfg.meta)?.data?.virtualIp
      const group = node.get('group');
      const textVirtualIpSharp = group.findById('text-virtualIp');
      textVirtualIpSharp.attr('text',virtualIp);

      if(cfg.repeatIp && (cfg.repeatIp as any[]).findIndex(c=>c===virtualIp)>-1){
        textVirtualIpSharp.attr('fill','#F56C6C');
      } else{
        textVirtualIpSharp.attr('fill','#000');
      }

      group.findAll((shape)=> shape.get('dataType')==='text-interface-ip')
        .forEach(shape=>{
          const dataIp=shape.get('dataIp');
          if(cfg.repeatIp && (cfg.repeatIp as any[]).findIndex(c=>c===dataIp)>-1){
            shape.attr('fill','#F56C6C');
          } else{
            shape.attr('fill','#000');
          }
        })
        
      
    },
    setState(name, value, item){
      const model={
        fill: value? '#d1edc4': '#fff',
        stroke: value? BorderSelectColor :  BorderColor,
        lineWidth: value? BorderSelectSize : BorderSize
      }
      const group = item.get('group');
      if(name==='selected'){
        const sharpList =  group.findAll(item=> {
          return item.get('type')==='rect' || item.get('type')==='circle';
        });
        sharpList.forEach(sharp=>{
          sharp.attr(model);
        });
      }
    },
  },
  'single-node',
);

}

function registerDeviceNode(){

  
G6.registerNode(
  nodeDeviceType,
  {
    drawShape: function drawShape(cfg, group) {
      const name= (<any>cfg.meta)?.data?.name;

      const r = 2;

      const keySharpe = group.addShape('rect', {
        attrs: {
          x: 0,
          y: 0,
          width: 120,
          height: 40,
          stroke: BorderColor,
          fill: '#fff',
          radius: r,
          lineWidth: BorderSize
        },
        name: 'key-sharper',
        draggable: true
      });

      group.addShape('text', {
        attrs: {
          textBaseline: 'top',
          x: 55,
          y: 5,
          fontSize: FontSize,
          text: name,
          fill: '#000',
        },
        id:'text-name',
        draggable: true
      });
      
      group.addShape('image', {
        attrs: {
          x: 12,
          y: 3,
          height: 35,
          width: 35,
          img: deviceImg,
          cursor: 'pointer',
        },
        name: 'pc-image',
        draggable: true
      });

      group.addShape('image', {
        attrs: {
          x: 95,
          y: 20,
          height: 15,
          width: 15,
          img: removeImg,
          cursor: 'pointer',
        },
        visible: cfg.removeFeature,
        name: 'remove-image',
        id: 'device-remove',
      });

      return keySharpe;
    },
    getAnchorPoints(cfg) {
      return  [[0,0.5],[1,0.5]];
    },
    afterDraw(cfg, group){
      const virtualIp= (<any>cfg.meta)?.data?.virtualIp;
      const physicalIp= (<any>cfg.meta)?.data?.physicalIp;
      const ipClone =  (<any>cfg.meta)?.data?.ipClone;
      const mode =  cfg.mode;
      const bbox = group.getBBox();
      
      group.addShape('text', {
        attrs: {
          textBaseline: 'top',
          x: -120,
          y: 5,
          fontSize: FontSize,
          text: mode==='pc-gateway'?'': (ipClone?physicalIp:virtualIp),
          fill: '#000',
        },
        id:'text-virtualIp'
      });
      group.addShape('text', {
        attrs: {
          textBaseline: 'top',
          x: 45,
          y: -15,
          fontSize: FontSize,
          text: mode==='pc-gateway'?'':physicalIp,
          fill: '#000',
        },
        id:'text-physicalIp'
      });

      const points = this.getAnchorPoints(cfg);
      points.forEach((anchorPos, i) => {
        group.addShape('circle', {
          attrs: {
            x: bbox.x + bbox.width * anchorPos[0],
            y: bbox.y + bbox.height * anchorPos[1],
            r: 10,
            fill: '#fff',
            stroke: BorderColor,
            lineWidth: BorderSize
          },
          anchorPointIdx: i, // flag the idx of the anchor-point circle
          name: `device-node-point-${i}`,
          links: 0, // cache the number of edges connected to this shape
          visible: true, // invisible by default, shows up when links > 1 or the node is in showAnchors state
          draggable: false // allow to catch the drag events on this shape
        });

        group.addShape('image', {
          attrs: {
            x: bbox.x + bbox.width * anchorPos[0] - 10,
            y: bbox.y + bbox.height * anchorPos[1] - 10,
            height: 20,
            width: 20,
            img: ethImg,
            cursor: 'pointer',
          },
          anchorPointIdx: i,
          name: `device-node-point-${i}-image`,
        });

      })
    },
    update(cfg,node){
      const metaModel = cfg.meta as IMetaModel;
      const deviceData = metaModel.data as DeviceData;
      const {
        virtualIp, physicalIp,
        name, ipClone
      } = deviceData;
      
      const group = node.get('group');
      const textVirtualIpSharp = group.findById('text-virtualIp');
      const textPhysicalIpSharp = group.findById('text-physicalIp');
      const textnameSharp = group.findById('text-name');
      const imageRemoveSharp = group.findById('device-remove');
      textVirtualIpSharp.attr('text',virtualIp);
      textPhysicalIpSharp.attr('text',physicalIp);
      textnameSharp.attr('text',name);
      if(ipClone){
        textVirtualIpSharp.attr('text',physicalIp);
      }

      if(cfg.repeatIp && (cfg.repeatIp as any[]).findIndex(c=>c===virtualIp)>-1){
        textVirtualIpSharp.attr('fill','#F56C6C');
      } else{
        textVirtualIpSharp.attr('fill','#000');
      }

      if(cfg.repeatIp && (cfg.repeatIp as any[]).findIndex(c=>c===physicalIp)>-1){
        textPhysicalIpSharp.attr('fill','#F56C6C');
      } else{
        textPhysicalIpSharp.attr('fill','#000');
      }

      if(cfg.removeFeature!=undefined){
        cfg.removeFeature?imageRemoveSharp.show():imageRemoveSharp.hide();
      }
      
    },
    setState(name, value, item){
      const model={
        fill: value? '#d1edc4': '#fff',
        stroke: value? BorderSelectColor :  BorderColor,
        lineWidth: value? BorderSelectSize : BorderSize
      }
      const group = item.get('group');
      if(name==='selected'){
        const sharpList =  group.findAll(item=> {
          return item.get('type')==='rect' || item.get('type')==='circle';
        });
        sharpList.forEach(sharp=>{
          sharp.attr(model);
        });
      }
    },
  },
  'single-node',
);



}

function registerPcDeviceEdge(){
  
G6.registerEdge(
  edgePcDeviceType,
  {
    afterDraw(cfg, group) {
      const {lineDash,running}=cfg;
      
      // get the first shape in the group, it is the edge's path here=
      const shape = group.get('children')[0];
      let index = 0;
      // Define the animation
      shape.animate(
        () => {
          index++;
          if (index > 9) {
            index = 0;
          }
          const res = {
            lineDash,
            lineDashOffset: -index,
          };
          // returns the modified configurations here, lineDash and lineDashOffset here
          return res;
        },
        {
          repeat: true, // whether executes the animation repeatly
          duration: 3000, // the duration for executing once
        },
      );
    },
  },
  'polyline', // extend the built-in edge 'cubic'
);

}

function registerGatewayDeviceEdge(){
  
G6.registerEdge(
  edgeGatewayDeviceType,
  {
    afterDraw(cfg, group) {
      // get the first shape in the group, it is the edge's path here=
      const shape = group.get('children')[0];
      // the start position of the edge's path
      const startPoint = shape.getPoint(0);

      // add red circle shape
      const circle = group.addShape('circle', {
        attrs: {
          x: startPoint.x,
          y: startPoint.y,
          fill: '#F6BD16',
          r: 4,
        },
        name: 'circle-shape',
      });

      // animation for the red circle
      circle.animate(
        (ratio) => {
          // the operations in each frame. Ratio ranges from 0 to 1 indicating the prograss of the animation. Returns the modified configurations
          // get the position on the edge according to the ratio
          const tmpPoint = shape.getPoint(ratio);
          // returns the modified configurations here, x and y here
          return {
            x: tmpPoint.x,
            y: tmpPoint.y,
          };
        },
        {
          repeat: true, // Whether executes the animation repeatly
          duration: 3000, // the duration for executing once
        },
      );
    },
  },
  'cubic', // extend the built-in edge 'cubic'
);
}

function g6Register(){
  registerPcNode();
  registerGatewayNode();
  registerDeviceNode();
  registerPcDeviceEdge();
  registerGatewayDeviceEdge();
}

g6Register();

const urlAlphabet =
    'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict'

export const nanoid = (size = 21) => {
    let id = ''
    // A compact alternative for `for (var i = 0; i < step; i++)`.
    let i = size
    while (i--) {
        // `| 0` is more compact and faster than `Math.floor()`.
        id += urlAlphabet[(Math.random() * 64) | 0]
    }
    return id
}


export function useExtranetUi(domId:string){
  return new ExtranetUi(domId)
}